export default __webpack_public_path__ + "static/media/T340_C_BD.2cba5e53.pdf";